import { ASINType, ObfuscatedMerchantIdType, StateCode } from "state/types";

/**
 * This method is used to mark if buyingoption is initiator screen or not.
 */
let initiatorScreenView = true
const buyingOptionReloaded = () => {
    initiatorScreenView = false
}

export enum BuyboxCSAAction {
    init = 'init',
    reload = 'reload'
}
/**
 * A CSA event for buybox
 * contentId: always be "buybox"
 * type: alwasy be "widget"
 * asin: current ASIN customer choose
 * action: identify if this metrics is sent when page render or triggered by state reselected
 *  - init: this event is sent when page render.
 *  - reload: sent when customer reselect state.
 * stateCode: the current state customer choose, or preselected stored in local storage., e.g. WA, CA etc.
 * offers: string type represent a list of merchants sorted by ranking (split by ','), corresponding to display order.
 */
export interface BuyboxCSAEvent {
    asin: ASINType, // current ASIN customer choose
    offers?: string, // a merchantId list separated by ","
    topRatedOffer?: ObfuscatedMerchantIdType, // a merchant Id for top rated badge winner
    stateCode?: StateCode // State code, e.g. WA, AL etc.
}

interface EmittedBuyboxCSAEvent extends BuyboxCSAEvent {
    action: string,
    contentId: string,
    type: string
}

const csa = (window as any).csa;

const emitBuyboxCSA = (event: BuyboxCSAEvent) => {
    if (!csa) {
        console.log(`csa is not available, do nothing.`);
        return;
    }
    const emittedEvent: EmittedBuyboxCSAEvent = {
        ...event,
        contentId: 'buybox',
        type: "widget",
        action: initiatorScreenView ? "init" : "reload"
    }
    const instance = csa("Content", {
        element: emittedEvent
    });
    // leverage a virtual content to send buybox data.
    // see https://info.analytics.a2z.com/#/docs/data_collection/csa/content_latency
    instance("mark", "loaded", Date.now());
}



export const CSA = { emitBuyboxCSA, buyingOptionReloaded } 